import { NotImplementedError } from "../../../../../errors";
import { parseRejectionReasonsResponse } from "../../../../../models/looker/modules/bidstream/rejectionReasons";
import { PromiseHandler } from "../../../../../handlers";
import { defaultDateRange, formatDateRange, priorPeriodDateRange } from "../../shared/dateRange";
import { RejectionReasonsFetchFailed } from "./errors";
import { REJECTION_REASONS_QUERY } from "./query";
class RejectionReasons extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-bidstream-rejection-reasons");
    }
    async findItems(filters) {
        const lineItemId = filters.where?.find((filter) => filter.field === "lineItemId")?.value;
        const datesFilter = filters.where?.find((filter) => filter.field === "dates")?.value;
        const dealIdsFilter = filters.where?.find((filter) => filter.field === "dealIds")?.value;
        const forceRefresh = filters.where?.find((filter) => filter.field === "forceRefresh")?.value === true;
        if (typeof lineItemId !== "string" || !lineItemId) {
            throw new Error("lineItemId filter is required");
        }
        const dates = Array.isArray(datesFilter) &&
            datesFilter.length === 2 &&
            datesFilter.every((date) => date instanceof Date)
            ? datesFilter
            : defaultDateRange();
        const dealIds = Array.isArray(dealIdsFilter)
            ? dealIdsFilter.filter((id) => typeof id === "string")
            : [];
        const buildQuery = (dateRange) => ({
            ...REJECTION_REASONS_QUERY,
            filters: {
                ...REJECTION_REASONS_QUERY.filters,
                "explore_bidstream_base.flt_lineitem_id": lineItemId,
                "explore_bidstream_base.flt_analysis_interval": formatDateRange(dateRange),
                // Looker string filters treat a comma-separated value as an OR list.
                ...(dealIds.length > 0 && {
                    "explore_bidstream_base.flt_deal_id": dealIds.join(",")
                })
            }
        });
        const priorDates = priorPeriodDateRange(dates);
        const queryBody = buildQuery(dates);
        const priorQueryBody = buildQuery(priorDates);
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        // Evicts this exact query's cache entry so the Refresh button always
        // hits the network instead of possibly replaying a stale cached result -
        // see the matching comment on Bidstream.findItems (../index.ts).
        if (forceRefresh) {
            this.cache.remove(hashKey);
        }
        // No built-in comparison measure, so trend comes from a second query,
        // diffed client-side in parseRejectionReasonsResponse.
        return this.cache.promise(hashKey, () => Promise.all([this.sdk.looker.query.run(queryBody), this.sdk.looker.query.run(priorQueryBody)])
            .then(([current, prior]) => [
            {
                data: parseRejectionReasonsResponse(current.data, prior.data),
                queryMeta: current.queryMeta
            }
        ])
            .catch((error) => {
            throw new RejectionReasonsFetchFailed(error);
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
export default RejectionReasons;
//# sourceMappingURL=index.js.map